import { clsx } from 'clsx'
import { CarouselStore } from 'component/Carousel/store/CarouselStore'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import css from './Arrow.module.scss'

type Props = {
  carousel: CarouselStore
  left?: boolean
  white?: boolean
}

export const Arrow = observer(({ carousel, left, white }: Props) => {
  const { index, items } = carousel
  const enabled = left ? index > 0 : index < items.length - 1
  const className = clsx(css.arrow, white && css.white, !enabled && css.disabled)

  const onClick = useLatestCallback(() => {
    if (!enabled) return
    const shift = left ? -1 : +1
    carousel.index += shift
  })

  return <Space className={className} onClick={onClick} center>
    <Icon name={left ? 'arrow_back' : 'arrow_forward'} size={16} />
  </Space>
})
